/* localStorage and Redux */
export const KEY: Record<string, StorageType> = {
  USER_INFO: 'userInfo',
  CART_ITEMS: 'cartItems',
  SHIPPING_ADDRESS: 'shippingAddress',
  CURRENCY: 'currency',
  HISTORY: 'history'
};
